import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: "1px solid #C6CACC",
    borderRadius: "4px",
  },
  counter: {
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
